import { render, staticRenderFns } from "./MyRouterLink.vue?vue&type=template&id=485bbfd2&scoped=true&lang=pug"
import script from "./MyRouterLink.vue?vue&type=script&lang=js"
export * from "./MyRouterLink.vue?vue&type=script&lang=js"
import style0 from "./MyRouterLink.vue?vue&type=style&index=0&id=485bbfd2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485bbfd2",
  null
  
)

export default component.exports